export default "__VITE_ASSET__Dyug3ASf__"